import seaways from 'seaways'
import { axiosClient } from '../../services/axios-client'

const http = seaways.createClient(axiosClient)

http.getCode = {
  method: 'get',
  path: '/projects/{projectId}/forms/{endpointId}/code'
}

http.setCode = {
  method: 'post',
  path: '/projects/{projectId}/forms/{endpointId}/code'
}

http.getPresets = {
  method: 'get',
  path: '/projects/{projectId}/forms/{endpointId}/emails'
}

http.importTemplate = {
  method: 'post',
  path: '/projects/{projectId}/forms/{endpointId}/import-template'
}

http.update = {
  method: 'put',
  path: '/projects/{projectId}/forms/{endpointId}/update'
}

http.create = {
  method: 'post',
  path: '/projects/{projectId}/forms/create'
}

http.remove = {
  method: 'delete',
  path: '/projects/{projectId}/forms/{endpointId}'
}

http.exportSubmissions = {
    method: 'post',
    path: '/projects/{projectId}/forms/{endpointId}/submissions/export'
}

http.removeAsset = {
  method: 'delete',
  path: '/projects/{projectId}/forms/{endpointId}/remove-asset'
}

http.sendTestEmail = {
  method: 'post',
  path: '/projects/{projectId}/forms/{endpointId}/test-email'
}

http.getSetting = {
  method: 'get',
  path: '/projects/{projectId}/forms/{endpointId}/settings'
}

http.updateSetting = {
  method: 'post',
  path: '/projects/{projectId}/forms/{endpointId}/settings'
}

http.moveTo = {
  method: 'patch',
  path: '/projects/{projectId}/forms/{endpointId}'
}

async function getCode({ projectId, endpointId }) {
  const requestOptions = { pathParams: { projectId, endpointId } }
  return (await http.getCode(requestOptions)).data
}

async function setCode({ projectId, endpointId, data }) {
  const requestOptions = {
    pathParams: { projectId, endpointId },
    data
  }
  return (await http.setCode(requestOptions)).data
}

async function create({ projectId, name }) {
  const requestOptions = {
    pathParams: {
      projectId
    },
    data: {
      project_id: projectId,
      name: name
    }
  }
  return (await http.create(requestOptions)).data
}

async function remove({ projectId, endpointId }) {
    const requestOptions = { pathParams: { projectId, endpointId } }
    return (await http.remove(requestOptions)).data
}

async function exportSubmissions({ projectId, endpointId, date }) {
    const requestOptions = { pathParams: { projectId, endpointId }, data: { date } }
    return (await http.exportSubmissions(requestOptions)).data
}

async function getSetting({ projectId, endpointId }) {
  const requestOptions = { pathParams: { projectId, endpointId } }
  return (await http.getSetting(requestOptions)).data
}

async function update({ projectId, endpointId, payload }) {
  const requestOptions = {
    pathParams: { projectId, endpointId },
    data: payload
  }
  return (await http.update(requestOptions)).data
}

async function updateSetting({ projectId, endpointId, payload }) {
    const requestOptions = {
        pathParams: { projectId, endpointId },
        data: payload
    }
    return (await http.updateSetting(requestOptions)).data
}

async function getPresets({ projectId, endpointId }) {
  const requestOptions = { pathParams: { projectId, endpointId } }
  return (await http.getPresets(requestOptions)).data
}

async function importTemplate({ projectId, endpointId, data }) {
  const requestOptions = { pathParams: { projectId, endpointId }, data }
  return (await http.importTemplate(requestOptions)).data
}

async function sendTestEmail({ projectId, endpointId, data }) {
  const requestOptions = { pathParams: { projectId, endpointId }, data }
  return (await http.sendTestEmail(requestOptions)).data
}

async function removeAsset({ projectId, endpointId, data }) {
  const requestOptions = { pathParams: { projectId, endpointId }, data }
  return (await http.removeAsset(requestOptions)).data
}

async function moveTo({ projectId, endpointId, projectIdForMove }) {
  const requestOptions = {
    pathParams: { projectId, endpointId },
    data: {
      project_id: projectIdForMove
    }
  }
  return (await http.moveTo(requestOptions)).data
}

export default {
  create,
  remove,
  exportSubmissions,
  update,

  removeAsset,
  updateSetting,
  sendTestEmail,
  importTemplate,

  getPresets,
  getSetting,

  moveTo,

  getCode,
  setCode
}
